export default {
  getHost: state => state.host,
  getUserNo: state => state.userNo,
  getUserName: state => state.userName,
  getLevelCode: state => state.levelCode,
  getAccessToken: state => state.accessToken,
  getRefreshToken: state => state.refreshToken,
  getIsAuth: state => state.isAuth
};
